import React from 'react';
import { MyModuleTypes, OneRosterDashboard, ScheduleSyncDashboard, SchoolAdminDashboard } from '../../../models/CoreDashboardModels';
import StatusCode from '../../../util/StatusCode';
import Loading from '../../misc/Loading';
import AuthorizedLink from '../../auth/AuthorizedLink';
import { FlowSyncAccessPolicy } from '../../../models/FlowSyncAccessPolicy';
import { useTranslation } from 'react-i18next';
import { RequestState } from '../../../models/RequestState';

const schoolAdmin = [
    { name: "object.schoolAdmin.school", cell: 'schoolUnits', link: "/schoolunit" },
    { name: "object.schoolAdmin.activity", cell: 'activities', link: "/activity" },
    { name: "object.schoolAdmin.group", cell: 'groups', link: "/group" },
    { name: "object.schoolAdmin.person", cell: 'users', link: "/user" },
];

const oneRoster = [
    { name: "object.oneRoster.school", cell: 'schoolUnits', link: "/oneroster/schoolunit" },
    { name: "object.oneRoster.section", cell: 'classes', link: "/oneroster/class?status=active" },
    { name: "object.oneRoster.user", cell: 'users', link: "/oneroster/user" },
];

const scheduleSync = [
    { name: "object.scheduleSync.user", cell: 'users', link: "/schedulesync/user/" },
    { name: "object.scheduleSync.calendarEvent", cell: 'events', link: "/schedulesync/event/" },
];

type StringMap = { [key: string]: number }

type Data = {
    name: string
    cell: string | number
    link: string
};

interface HomeGeneralModulesProps {
    myModuleTypes: RequestState<MyModuleTypes>
    schoolAdminInfo: RequestState<SchoolAdminDashboard>
    oneRosterInfo: RequestState<OneRosterDashboard>
    scheduleSyncInfo: RequestState<ScheduleSyncDashboard>
}


const HomeGeneralModules = (props: HomeGeneralModulesProps) => {
    const { t } = useTranslation(['common']);

    const renderGeneralModuleTypes = () => {
        if (props.myModuleTypes.code === StatusCode.PENDING) {
            return <Loading />;
        };
        if (props.myModuleTypes.code === StatusCode.ERROR) {
            return t('error.getGeneralInfo', { ns: 'common' });
        };
        if (props.myModuleTypes.code === StatusCode.COMPLETE) {
            let modules = [];
            for (const [key, value] of Object.entries(props.myModuleTypes.data)) {
                if (value) {
                    modules.push(key)
                }
            };
            return modules.map(x => {
                return <span key={x}>{ModuleType(x)}</span>
            });
        };
    };

    const ModuleType = (value: string) => {
        switch (value) {
            case "schoolAdmin": return renderFlowSyncInfo(props.schoolAdminInfo, t('nav.schoolAdmin', { ns: 'common' }), schoolAdmin);
            case "oneRoster": return renderFlowSyncInfo(props.oneRosterInfo, t('nav.oneRoster', { ns: 'common' }), oneRoster);
            case "scheduleSync": return renderFlowSyncInfo(props.scheduleSyncInfo, t('nav.scheduleSync', { ns: 'common' }), scheduleSync);
            default: return;
        }
    };

    const renderFlowSyncInfo = (info: RequestState<StringMap>, header: string, data: Data[]) => {
        return (
            <div className="dashboard_module">
                <div className="dashboard_top">
                    <h5>{header}</h5>
                </div>
                <div className="dashboard_content">
                    {(() => {
                        switch (info.code) {
                            case StatusCode.PENDING: return <Loading />;
                            case StatusCode.ERROR: return <p>{t('error.getDashboardInfo', { ns: 'common' })}</p>;
                            case StatusCode.COMPLETE: {
                                return (
                                    data.map((x, i) => (
                                        <p key={i}>
                                            <AuthorizedLink accessPolicy={FlowSyncAccessPolicy.READ} to={x.link}>
                                                {`${t(x.name, { ns: 'common', count: 2 })}: ${info.data[x.cell].toLocaleString()}`}
                                            </AuthorizedLink>
                                        </p>
                                    ))
                                )
                            }
                        }
                    })()}
                </div>
            </div>);
    }

    return (<>
        {renderGeneralModuleTypes()}
    </>);
}

export default HomeGeneralModules;
